import { render, staticRenderFns } from "./OrganizationInviteUser.vue?vue&type=template&id=4b7a4cf6&"
import script from "./OrganizationInviteUser.vue?vue&type=script&lang=js&"
export * from "./OrganizationInviteUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports